// Microsoft Authentication Library (MSAL) config.
// These IDs come from the Entra App Registration IT created. Neither is a
// secret — client/tenant IDs are public identifiers, safe to keep in source.

export const msalConfig = {
  auth: {
    // Application (client) ID from the App Registration
    clientId: "0c756eee-2d02-41c2-8a83-bd424c19822f",
    // Single-tenant authority = ONLY Hardaway directory accounts can sign in
    authority: "https://login.microsoftonline.com/7d18b0fc-adfb-4cd2-9e34-e8ab448efdab",
    // Must match the SPA Redirect URI registered in Entra. window.location.origin
    // resolves to the live SWA URL in prod and http://localhost:3000 in dev.
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    // Land back on the home page after sign-in (avoids bouncing to /login).
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    // Helps the redirect sign-in complete reliably across browsers.
    storeAuthStateInCookie: true,
  },
};

// Scopes requested at sign-in.
// User.Read = read the signed-in person's basic profile. That is all Delphi needs:
// app data lives in Azure SQL behind /api/data, reached with this same id_token.
// Sites.ReadWrite.All was dropped when the SharePoint data layer was retired —
// it granted read/write across every Hardaway site for an integration that no
// longer exists. The matching permission should be removed from the Entra app
// registration too, not just from this request.
export const loginRequest = {
  scopes: ["User.Read"],
};

// --- Role assignment (handled in-app by email, no Entra groups needed) ---
// Anyone in the Hardaway directory who signs in gets "executive" (view + analyze).
// Emails listed here get "admin" (can also reach the Import screen).
export const ADMIN_EMAILS = [
  "bbarnes@hardaway.net",
  "sfreeman@hardaway.net",  // Scott Freeman
  "phannon@hardaway.net",   // Pat Hannon
  "kbroihier@hardaway.net", // Kelly Broihier
];

// Emails with the "finance" role — can edit the Financials tab (runoff matrix,
// contract values, % complete). Admins can too. Everyone else sees it read-only.
// Others can be granted finance via the IsFinance flag on their People record.
export const FINANCE_EMAILS = [
  "bbarnes@hardaway.net",
  "phannon@hardaway.net",   // Pat Hannon — owns the runoff report
  "pbrowne@hardaway.net",   // Patrick Brown — finance (runoff matrix editing)
];

// Optional: restrict access to ONLY specific people (left empty = all directory
// users can view).
export const EXECUTIVE_EMAILS = [
];